"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var utils_1 = require("../../../utils");

var Parser_1 = require("../Parser");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var MapParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(MapParser, _Parser_1$Parser);

  function MapParser(members) {
    var _this;

    _classCallCheck(this, MapParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapParser).call(this));
    _this.members = members;
    return _this;
  }

  _createClass(MapParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (!utils_1.Utils.isObject(input)) {
        return new ValidationResult_1.ValidationError(MapParser.NOT_AN_OBJECT_ERROR);
      }

      var ret = [];

      for (var k in input) {
        if (input.hasOwnProperty(k)) {
          var m = this.members.validate(input[k], level || ValidationLevel_1.ValidationLevel.Basic);

          if (!m.valid) {
            return m;
          }

          ret.push([k, m.value]);
        }
      }

      return new ValidationResult_1.ValidationSuccess(immutable_1.Map(ret));
    }
  }]);

  return MapParser;
}(Parser_1.Parser);

exports.MapParser = MapParser;
MapParser.NOT_AN_OBJECT_ERROR = 'NOT_AN_OBJECT';